import React from 'react'
import { useIsMobile } from 'hooks/useIsMobile';

export function BtnWhats(){
    
    const { isMobile } = useIsMobile();

    return(
        <>
            {isMobile
                ? isMobile === 'desktop'
                    ? <a href="https://wa.me/5215591793394" className="icoWhats"></a>
                    : isMobile === 'movil'
                        ? <a href="https://wa.me/5215591793394" className="icoWhats"></a>
                        : null
                : null
            }
        </>
    )
}